import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import { PaymentMollieProfileDataInterface } from 'modules/profile/payment-gateways/integrations/mollie/types'
import httpClient from 'shared/utils/http-client'

export const mollieDisconnect = () => httpClient.post(`${PAYMENT_GATEWAYS_API}/mollie/disconnect`)

export const mollieChangeProfile = (data: PaymentMollieProfileDataInterface) =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/mollie/change-profile`, data)
